import { existsSync } from "node:fs";
import { dirname, resolve } from "node:path";
import { fileURLToPath } from "node:url";

const getCurrentFileDir = (): string => dirname(fileURLToPath(import.meta.url));

export const resolveBundledSkillsDir = (): string => {
  const currentDir = getCurrentFileDir();
  const candidates = [
    resolve(currentDir, "..", "skills"),
    resolve(currentDir, "..", "..", "skills"),
    resolve(currentDir, "..", "..", "..", "skills"),
  ];
  for (const candidate of candidates) {
    if (existsSync(candidate)) return candidate;
  }
  throw new Error(
    `Could not locate the bundled skills directory. Checked: ${candidates.join(", ")}`,
  );
};
